import { Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from '@mui/material/Button';
import Link from '@mui/material/Link';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';

const ReportProblemLink = (props) => {
  const { feedbackSubject, attachments, children, type, onClick, ...linkProps } = props;
  const dispatch = useDispatch();
  const feedback = useSelector((state) => featureFlagsSelectors.getFeatureFlag(state, 'feedback'));

  if (!feedback) {
    return null;
  }

  if (type === 'button') {
    return (
      <Button
        variant={'tonal'}
        onClick={(event) => {
          dispatch(
            rootUiActions.createDialog(
              rootUiTypes.mkRootUiData({
                id: 'report-error',
                type: 'DIALOG_TYPE_REPORT_ERROR',
                allowNesting: true,
                props: ImmutableMap({
                  feedbackSubject,
                  attachments,
                }),
              }),
            ),
          );
          onClick?.(event);
        }}
        sharedcomponentid={'REPORT_PROBLEM_LINK'}
        {...linkProps}
      >
        {children || 'Send feedback'}
      </Button>
    );
  }

  return (
    <Link
      component='button'
      onClick={(event) => {
        dispatch(
          rootUiActions.createDialog(
            rootUiTypes.mkRootUiData({
              id: 'report-error',
              type: 'DIALOG_TYPE_REPORT_ERROR',
              allowNesting: true,
              props: ImmutableMap({
                feedbackSubject,
                attachments,
              }),
            }),
          ),
        );
        onClick?.(event);
      }}
      sharedcomponentid={'REPORT_PROBLEM_LINK'}
      underline='none'
      {...linkProps}
    >
      {children || 'Send feedback'}
    </Link>
  );
};

ReportProblemLink.propTypes = {
  feedbackSubject: PropTypes.string,
  attachments: PropTypes.object,
  children: PropTypes.any,
  type: PropTypes.string,
  onClick: PropTypes.func,
  // for props ferry to link
  sx: PropTypes.object,
};

export default ReportProblemLink;
